class Event {
  _init = async () => {
    return true
  }

  resolve = async (event, data = null) => {
    let _event = {}
    if (!event.type) {
      event = {
        type: event,
        detail: data
      }
    }

    /* Library-specific Event */
    if (event.type === "channel_changed" || event.type === "channel_status_changed") {
      _event.name = event.type
      if (event.type === "channel_changed" && event.result) this._setVideoSize()
      if (!__.media.hasPlayer()) hcap.channel.stopCurrentChannel({})
    }

    /* Platform-specific Event */
    if (event.type === "hcap_application_focus_changed" && !__.source.isExternal) {
      if (event.eventType === "focused") _event.name = "applicationFocusing"
      else _event.name = "applicationUnfocused"
      await _$.sleep(1000)
    } else if (event.type === "channel_status_changed") {
      const promise = await _$.progress.create()
      hcap.channel.getCurrentChannel({
        onSuccess: payload => promise.resolve(payload.channelStatus),
        onFailure: payload => promise.reject(payload.errorMessage)
      })
      const channelStatus = await promise.done
      if ([33, 0].indexOf(channelStatus) >= 0 || typeof channelStatus === "boolean") return false

      _event.name = "mediaPlaying"
    } else if (event.type === "media_event_received") {
      let tempName,
        data = event.eventType || event.detail
      switch (data) {
        case "play_start":
        case "seek_done":
          this._setVideoSize()
          tempName = "mediaPlaying"
          break
        case "play_end":
          tempName = "mediaEnded"
          break
        case "play_stop":
          tempName = "mediaStopped"
          break
        case "play_pause":
          tempName = "mediaPaused"
          break
        default:
          return false
      }
      _event.name = tempName
    } else if (event.type === "external_input_changed") {
      _event.name = "source"
      _event.data = await __._source.get()

      //if (_event.data === "1" && !__.media.hasPlayer()) hcap.channel.stopCurrentChannel({})

      if (_event.data === "8") return false
      if (_event.data === "9") return false
      else if (_event.data === __.source.current) return false

      if (_event.data === "1") await _$.sleep(1000)
    } else if (event.type === "power_mode_changed") {
      _event.name = "power"
      _event.data = await __._device.getPowerState()
    } else if (["udp_data_received", "tcp_data_received"].includes(event.type) && event.port === 4000) {
      let socketData = null
      try {
        socketData = window.atob(event.data)
        socketData = JSON.parse(socketData)
      } catch (e) {
        return _$.error(e)
      }
      if (socketData.hasOwnProperty("action")) _$.vue.$emit("action", socketData)
      else if (socketData.hasOwnProperty("weather")) _$.vue.$emit("weather", socketData)
      else if (socketData.hasOwnProperty("chromecast")) _$.vue.$emit("chromecast", socketData)
      else if (socketData.hasOwnProperty("rc")) _$.vue.$emit("rc-command", socketData)
      return false
    }
    return _event
  }
  _setVideoSize = async () => {
    const { width, height, x, y, index } = __.common.tvWindowMetrics

    return __._common.setTvWindowSize({ width, height, x, y, index }, true).catch(err => _$.error(err))
  }
}

export default Event
